<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">客户回访<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>回访门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>回访类型</label>
              <el-select v-model="projectServiceType" placeholder="Select" class="select-item">
                <el-option v-for="item in projectServiceTypeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="预访时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>
            <div class="content-input-item">
              <label>回访状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <label style="margin-left: 24px">复核状态</label>
              <el-select v-model="recheckState" placeholder="Select" class="select-item">
                <el-option v-for="item in recheckStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>超时回访</label>
              <el-select v-model="visitOvertime" placeholder="Select" class="select-item">
                <el-option v-for="item in visitOvertimeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <label style="margin-left: 24px">超时复核</label>
              <el-select v-model="recheckOvertime" placeholder="Select" class="select-item">
                <el-option v-for="item in recheckOvertimeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <!--              <label>客户搜索</label>-->
              <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
                          <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap">有限制</span></el-checkbox>
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-space v-if="(operateState & 2) == 2">
              <el-button type="primary" @click="batchUpdateRecheckState" v-loading="batchLoading" size="default">批量指定复核</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-badge is-dot :hidden="auditNum == 0">
                <el-button @click="buttonTypeChange(4, true)">审核中<span v-if="auditNum > 0">（{{auditNum}}）</span></el-button>
              </el-badge>
            </el-space>
            <el-space v-else>
              <el-button type="primary" @click="batchUpdateVisit" v-loading="batchLoading" size="default">批量回访</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-badge is-dot :hidden="needVisitNum == 0">
                <el-button @click="buttonTypeChange(1, true)">需回访<span v-if="needVisitNum > 0">（{{needVisitNum}}）</span></el-button>
              </el-badge>
              <el-badge is-dot :hidden="needRecheckNum == 0">
                <el-button @click="buttonTypeChange(2, true)">需复核<span v-if="needRecheckNum > 0">（{{needRecheckNum}}）</span></el-button>
              </el-badge>
              <el-badge is-dot :hidden="recheckNoPassNum == 0">
                <el-button @click="buttonTypeChange(3, true)">复核不通过<span v-if="recheckNoPassNum > 0">（{{recheckNoPassNum}}）</span></el-button>
              </el-badge>
            </el-space>
          </div>
          <div style="display: flex;align-items: center;">
            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
          </div>

        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              @selection-change="selsChange"
              @header-click="selsAll"
              size="default"
              border
          >
            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
            <el-table-column property="createTime" label="预访时间" v-if="checkColList.indexOf('预访时间') > -1" width="110"/>
            <el-table-column property="shopName" label="回访门店" v-if="checkColList.indexOf('回访门店') > -1" width="110"/>

            <el-table-column property="" label="客户信息" v-if="checkColList.indexOf('客户信息') > -1" width="160">
              <template #default="scope">
                <p @click="userInfoDialog(scope.row.userId)">主人：<span style="color: #3a8ee6; cursor: pointer">{{scope.row.userName}}</span></p>
                <p>性别：{{scope.row.userSex ==1?'男':scope.row.userSex ==2?'女':'未知'}}</p>
                <p>手机：{{scope.row.phone}}</p>
                <p>门店：{{scope.row.userShopName}}</p>
                <p>主人ID：{{scope.row.uid}}</p>
              </template>
            </el-table-column>
            <el-table-column property="projectName" label="猫咪信息" v-if="checkColList.indexOf('猫咪信息') > -1" class-name="cursor">
              <template #default="scope">
                <div style="margin: 8px 0;" v-for="(item, index) of scope.row.petList" :key="item.id">
                  <p>{{item.petBreedColorName}}{{item.woolState == 1?'短毛':item.woolState == 2?'长毛':''}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}</p>
                  <p v-if="item.exemptionDesc" style="color: red; font-size: 12px">*{{item.exemptionDesc}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="" label="回访类型" v-if="checkColList.indexOf('回访类型') > -1" width="90">
              <template #default="scope">
                {{scope.row.projectServiceType == 1?'洗澡项目':scope.row.projectServiceType == 2?'增值项目':scope.row.projectServiceType == 3?'物品销售':scope.row.projectServiceType == 4?'活体销售':scope.row.projectServiceType == 5?'其他':''}}
              </template>
            </el-table-column>
            <el-table-column property="" label="回访描述" v-if="checkColList.indexOf('回访描述') > -1">
              <template #default="scope">
                <p>回访项目：{{scope.row.name}}</p>
                <p>回访天数：{{scope.row.dayNum == -1?'无需回访':scope.row.dayNum == 0?'立即回访':scope.row.dayNum}}</p>
              </template>
            </el-table-column>
            <el-table-column property="" label="回访状态" v-if="checkColList.indexOf('回访状态') > -1" width="90">
              <template #default="scope">
                {{scope.row.state == 0?'未回访':scope.row.state == 1?'已超时':scope.row.state == 2?'已回访':''}}
              </template>
            </el-table-column>
            <el-table-column property="" label="复核状态" v-if="checkColList.indexOf('复核状态') > -1" width="98">
              <template #default="scope">
                {{scope.row.recheckState == 1?'待复核':scope.row.recheckState == 2?'已超时':scope.row.recheckState == 3?'审核中':scope.row.recheckState == 4?'资料驳回':scope.row.recheckState == 5?'不通过':scope.row.recheckState == 6?'已通过':''}}
                <div v-if="(operateState & 2) != 2">
                  <el-button v-if="scope.row.recheckState == 1 || scope.row.recheckState == 2 || scope.row.recheckState == 3 || scope.row.recheckState == 4" type="primary" size="small" @click="editRecheckDialog(scope.$index,scope.row)">上传截图</el-button>
<!--                  <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png,.heic"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">-->
                </div>
              </template>
            </el-table-column>
<!--            <el-table-column property="" label="超时回访" v-if="checkColList.indexOf('超时回访') > -1" width="90">-->
<!--              <template #default="scope">-->
<!--                {{scope.row.visitOvertime == 0?'未超时':scope.row.visitOvertime == 1?'已超时':''}}-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column property="" label="超时复核" v-if="checkColList.indexOf('超时复核') > -1" width="90">-->
<!--              <template #default="scope">-->
<!--                {{scope.row.recheckOvertime == 0?'未超时':scope.row.recheckOvertime == 1?'已超时':''}}-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column property="" label="回访截图" v-if="checkColList.indexOf('回访截图') > -1" width="100">
              <template #default="scope">
                <div v-if="scope.row.visitImgList && scope.row.visitImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
                  <el-image class="item-img" fit="fill" :src="scope.row.visitImgList[0].img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
                <div v-else>
                  <el-image class="item-img" fit="fill"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="110">
              <template #default="scope">
                <el-space wrap  v-if="(operateState & 2) == 2">
                  <div v-if="scope.row.state == 2">
                    <el-button v-if="scope.row.recheckState == 3 || scope.row.recheckState == 4 || scope.row.recheckState == 5 || scope.row.recheckState == 6" @click="editRecheckDialog(scope.$index,scope.row)" size="small" type="primary">复核审核</el-button>
                    <el-button v-else  @click="updateRecheckState(scope.$index,scope.row)" size="small" type="primary" v-loading="scope.row.updateLoading">指定复核</el-button>
                  </div>
                </el-space>
                <el-space wrap v-else>
                  <el-button v-if="scope.row.recheckState != 5 || scope.row.recheckState != 6" @click="editVisitDialog(scope.$index,scope.row)" size="small" type="primary">回访</el-button>
                </el-space>
              </template>
            </el-table-column>
            <el-table-column property="" label="回访详情" v-if="checkColList.indexOf('回访详情') > -1">
              <template #default="scope">
                <div v-if="scope.row.state == 2">
                  <p>{{ scope.row.visitTime }}<el-tag size="small" style="margin-left: 8px;" v-if="scope.row.visitAdminName">{{scope.row.visitAdminName}}</el-tag></p>
                  <p>回访项目：{{ scope.row.name }}</p>
                  <p>回访满意度：{{ scope.row.satisfaction == 1?'不满意':scope.row.satisfaction == 2?'一般':scope.row.satisfaction == 3?'满意':scope.row.satisfaction == 4?'未回复':'' }}</p>
                  <p>问题反馈：{{ scope.row.problem }}</p>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="display: flex; justify-content: space-between">
            <el-table
                :data="sumDataList"
                style="width: 60em; margin-top: 16px;"
                v-loading="listLoading"
                size="default"
                border
            >
              <el-table-column property="" label="汇总" width="80"></el-table-column>
              <el-table-column property="sumVisited" label="已回访总数"></el-table-column>
              <el-table-column property="overtimeNoVisit" label="超时未回访次数"></el-table-column>
              <el-table-column property="overtimeNoRecheck" label="超时未复核次数"></el-table-column>
              <el-table-column property="recheckPass" label="复核通过数"></el-table-column>
              <el-table-column property="recheckNoPass" label="复核不通过数"></el-table-column>
            </el-table>
            <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData,imgPostFormData } from "@/api/api";
import {
  getVisitPageList,
  updateShopProjectState,
  getVisitSummaryPageList,
  updateVisitState,
  updateVisitRecheckState,
  getVisitStatStateNum,
  getSysListMenuTag
} from "@/api/url";
// import UserDialog from "./components/UserDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserRemark from "@/components/Remark/UserRemark";
import UserRemarkDialog from "@/components/Remark/UserRemarkDialog";
import UserLogList from "@/components/UserLogList/UserLogList";
import UserLogListDialog from "@/components/UserLogList/UserLogListDialog";
import UserInfo from "@/components/User/userInfo"
import ConsumeList from "@/views/user/components/ConsumeList";
import {add, decimal_NUM, Number_SubAll} from "@/assets/shared/util";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import unLock from "@/layout/components/unLock";
import DatePickerRange from "@/components/DatePickerRange";
import visitDialog from "@/views/visit/components/visitDialog";
import UserImgUpload from "@/components/imgList/UserImgUpload";
import RecheckDialog from "@/views/visit/components/RecheckDialog";
import userInfoDialog from "@/components/User/userInfoDialog";
import PetListDialog from "@/views/user/components/PetListDialog";

export default {
  name: "VisitIndex",
  components: { BtnGroup, SearchComponents, UserRemark, UserInfo, ConsumeList, UserLogList, unLock, DatePickerRange},
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,
      batchLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      projectServiceTypeArray: [
        {label: '不限', value: -1},
        {label: '洗澡项目', value: 1},
        {label: '增值项目', value: 2},
        {label: '物品销售', value: 3},
        {label: '活体销售', value: 4},
        {label: '其他', value: 5},
      ],
      projectServiceType: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '未回访', value: 0},
        // {label: '已超时', value: 1},
        {label: '已回访', value: 2}
      ],
      state: 0,

      recheckStateArray: [
        {label: '不限', value: -1},
        {label: '待复核', value: 1},
        // {label: '已超时', value: 2},
        {label: '审核中', value: 3},
        {label: '资料驳回', value: 4},
        {label: '不通过', value: 5},
        {label: '已通过', value: 6},
      ],
      recheckState: -1,

      visitOvertimeArray: [
        {label: '不限', value: -1},
        {label: '未超时', value: 0},
        {label: '已超时', value: 1}
      ],
      visitOvertime: -1,

      recheckOvertimeArray: [
        {label: '不限', value: -1},
        {label: '未超时', value: 0},
        {label: '已超时', value: 1}
      ],
      recheckOvertime: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //刷新组
      colList: ['预访时间', '回访门店', '客户信息', '猫咪信息', '回访类型', '回访描述', '回访状态', '复核状态','回访截图', '操作', '回访详情'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '主人', value : 2},
        {label : '宠物昵称', value : 3},
        {label : '主人ID', value : 4},
      ],
      searchType: 1,
      searchValue: '',
      limitState: false,

      upUserLoading: false,
      upPetLoading: false,

      buttonType: -1,

      idArray: [],

      uploadImgId: 0,

      operateState: JSON.parse(sessionStorage.getItem('operateState')),

      auditNum: 0,
      needRecheckNum: 0,
      needVisitNum: 0,
      recheckNoPassNum: 0,

    }
  },
  methods: {

    userInfoDialog(id) {
      Dialog.open({
        title: '',
        component: userInfoDialog,
        data: {
          userId: id,
          width: '640px',
        },
        confirm: () => {
        }
      })
    },

    // //更改或添加
    // fileUpdate(id) {
    //   this.uploadImgId = id
    //   this.$refs.file.setAttribute('type', 'file')
    //   this.$refs.file.click();
    // },
    //
    // //选取图片
    // fileChanged(e) {
    //   if(e.target.files[0]) {
    //     let imgArr = []
    //     for(let item of e.target.files) {
    //       let windowURL = window.URL || window.webkitURL;
    //       let src = windowURL.createObjectURL(item);
    //       let obj = {'img': src, 'smallImg': src, 'files': item};
    //       // this.imgArray.push(obj);
    //       imgArr.push(obj)
    //     }
    //         this.$refs.file.setAttribute('type', 'text')
    //     Dialog.open({
    //       title: '上传回访图片',
    //       component: UserImgUpload,
    //       data: {
    //         imgArray: imgArr,
    //         id: this.uploadImgId,
    //         width: '800px',
    //         from: 4,
    //       },
    //       confirm: (result) => {

    //         this.getPage()
    //       }
    //     })
    //   }
    // },

    userImgList(row) {
      let _title = '';
      _title = '回访图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.visitImgList,
          id: row.id,
          width: 908,
          from: 4,
          hideBtn: (this.operateState & 2)  == 2 || row.recheckState == 5 || row.recheckState == 6
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.limitState = false;
      this.projectServiceType = -1;
      this.recheckState = -1;
      this.state = -1;
      this.buttonType = -1;
      this.visitOvertime = -1;
      this.recheckOvertime = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    buttonTypeChange(state,reset) {
      this.buttonType = state
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;

        let param = {};
        param['pageNum'] = this.currentPage;
        param['shopId'] = this.shopId;
        param['projectServiceType'] = -1;
        param['state'] = -1;
        param['recheckState'] = -1;
        param['buttonType'] = this.buttonType;
        param['searchType'] = 1;
        param['searchValue'] = '';
        param['limitState'] = 0;
        param['startTime'] = '';
        param['endTime'] = '';

        this.sendPageReq(param);
      }
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      if(this.buttonType == -1) {
        this.getPage();
      }else {
        this.buttonTypeChange(this.buttonType)
      }
    },


    getPage(reset) {
      this.buttonType = -1
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
          // this.buttonType = -1
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['projectServiceType'] = this.projectServiceType;
      param['state'] = this.state;
      param['recheckState'] = this.recheckState;
      param['buttonType'] = this.buttonType;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['visitOvertime'] = this.visitOvertime;
      param['recheckOvertime'] = this.recheckOvertime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getVisitPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.getSumPage(param)
          this.getStatNum()
          this.getMenuTag()
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getSumPage(param) {
      getFormData(getVisitSummaryPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.sumDataList = []
          let result = data['data'];
          this.sumDataList.push(result)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
          .catch((response) => {
          })
    },

    compare(a, b) {
      const bandA = a.shopId;
      const bandB = b.shopId;

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editVisitDialog(idx, row) {
      let _title = '回访详情';
      let visitForm = Object.assign({}, row);
      Dialog.open({
        title: _title,
        component: visitDialog,
        data: {
          visitForm: visitForm,
          ids: idx,
          width: '600px',
          shopId: row.shopId,
        },
        confirm: (result) => {
          if(this.buttonType == -1) {
            this.getPage();
          }else {
            this.buttonTypeChange(this.buttonType)
          }
        }
      })
    },

    editRecheckDialog(idx, row) {
      let _title = '';
      let recheckForm = Object.assign({}, row);
      Dialog.open({
        title: _title,
        component: RecheckDialog,
        data: {
          recheckForm: recheckForm,
          width: '640px',
          operateState: this.operateState
        },
        close: (result) => {
          if(this.buttonType == -1) {
            this.getPage();
          }else {
            this.buttonTypeChange(this.buttonType)
          }
        }
      })
    },

    batchUpdateVisit() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选择回访记录',
          type: 'warning'
        });
        return false
      }
      this.$confirm('确定批量回访吗？').then(() => {
        this.batchLoading = true
        let param = {};
        param['idArr'] = this.idArray;
        postFormData(updateVisitState, param).then(data => {
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.batchLoading = false;
        }).catch(()=> {
          this.batchLoading = false;
        })
      })
    },

    batchUpdateRecheckState() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选择回访记录',
          type: 'warning'
        });
        return false
      }
      this.$confirm('确定批量指定复核吗？').then(() => {
        this.batchLoading = true
        let param = {};
        param['idArr'] = this.idArray;
        param['recheckState'] = 1;
        postFormData(updateVisitRecheckState, param).then(data => {
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.batchLoading = false;
        }).catch(()=> {
          this.batchLoading = false;
        })
      })
    },


    updateRecheckState(idx, row) {
      this.$confirm('确定指定复核该客户的回访信息吗？').then(() => {
        row.updateLoading = true
        let arr = []
        arr.push(row.id)
        let param = {};
        param['idArr'] = arr;
        param['recheckState'] = 1;
        postFormData(updateVisitRecheckState, param).then(data => {
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            if(this.buttonType == -1) {
              this.getPage();
            }else {
              this.buttonTypeChange(this.buttonType)
            }
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.updateLoading = false;
        }).catch(()=> {
          row.updateLoading = false;
        })
      })
    },


    updateState(row, state) {
      row.updateLoading = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateShopProjectState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        row.updateLoading = false;
      }).catch(()=> {
        row.updateLoading = false;
      })
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      if(column.label == '猫咪信息') {
        let editable = true
        Dialog.open({
          title: '猫咪信息',
          component: PetListDialog,
          data: {
            userForm: row,
            petList: row.petList,
            editable: editable,
            width: '1100px',
            userId: row.userId,
          },
          close: () => {
            if(JSON.parse(sessionStorage.getItem('recordState'))) {
              this.getPage()
            }
            sessionStorage.removeItem('recordState')
          }
        })
      }

    },

    getStatNum() {
      getFormData(getVisitStatStateNum, {id: this.shopId}).then(data => {
          this.auditNum = data.data.auditNum
          this.needRecheckNum = data.data.needRecheckNum
          this.needVisitNum = data.data.needVisitNum
          this.recheckNoPassNum = data.data.recheckNoPassNum
      })
    },

    // getMenuTag() {
    //   getFormData(getSysListMenuTag).then(data => {
    //     let list = data.data
    //     let tagList = []
    //     list.map(item => {
    //       if(item.tagNum > 0) {
    //         tagList.push(item.menuId)
    //       }
    //     })
    //     this.$store.commit('UPDATE_MENU_TAG_LIST', tagList)
    //   })
    // },

    getMenuTag() {
      getFormData(getSysListMenuTag).then(data => {
        let list = data.data
        let tagList = []
        list.map(item => {
          if(item.tagNum > 0) {
            tagList.push(item.menuId)
          }
        })
        let menuList = JSON.parse(localStorage.getItem('menuList'))
        menuList.map(item => {
          if(item.children && item.children.length > 0) {
            for(let i=0; i<item.children.length; i++) {
              if(tagList.indexOf(item.children[i].id) > -1) {
                tagList.push(item.id)
                break;
              }
            }
          }
        })
        this.$store.commit('UPDATE_MENU_TAG_LIST', tagList)
      })
    },




  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })

    // let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.shopId = this.shopIdArray[0].id
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/

.item-img {
  width: 80px;
  height: 80px;
}
</style>
